// data/languages/swahili/categories/corps.ts

import { CategoryData } from '../../../../types/types';

export const corps: CategoryData = {
  'Kichwa': { translation: 'Tête', translationEn: 'Head', illustration: '🧠', audio: 'Sw-kichwa' },
  'Macho': { translation: 'Yeux', translationEn: 'Eyes', illustration: '👁️', audio: 'Sw-macho' },
  'Pua': { translation: 'Nez', translationEn: 'Nose', illustration: '👃', audio: 'Sw-pua' },
  'Paji la uso': { translation: 'Front', translationEn: 'Forehead', illustration: '', audio: 'Sw-paji la uso' },
  'Mdomo': { translation: 'Bouche', translationEn: 'Mouth', illustration: '👄', audio: 'Sw-mdomo' },
  'Sikio': { translation: 'Oreille', translationEn: 'Ear', illustration: '👂', audio: 'Sw-sikio' },
    'Goti': { translation: 'Genou', translationEn: 'Knee', illustration: '🦵', audio: 'Sw-goti' },
  'Mkono': { translation: 'Bras / Main', translationEn: 'Arm / Hand', illustration: '💪🤚', audio: 'Sw-mkono' },
  'Kope': { translation: 'Cil', translationEn: 'Eyelash', illustration: '👃', audio: 'Sw-kope' },
  'Mguu': { translation: 'Jambe / Pied', translationEn: 'Leg / Foot', illustration: '🦵👣', audio: 'Sw-mguu' },
   'Paja': { translation: 'Cuisse', translationEn: 'Thigh', illustration: '🦵', audio: 'Sw-paja' },
  'Moyo': { translation: 'Cœur', translationEn: 'Heart', illustration: '❤️', audio: 'Sw-moyo' },
  'Uso': { translation: 'Visage', translationEn: 'Face', illustration: '😊', audio: 'Sw-uso' },
  'Ngozi': { translation: 'Peau', translationEn: 'Skin', illustration: '', audio: 'Sw-ngozi' },
  'Tumbo': { translation: 'Ventre', translationEn: 'Belly', illustration: '🫃', audio: 'Sw-tumbo' },
  'Mgongo': { translation: 'Dos', translationEn: 'Back', illustration: '', audio: 'Sw-mgongo' },
   'Mfupa': { translation: 'Os', translationEn: 'Bone', illustration: '🦴', audio: 'Sw-mfupa' },
  'Kidole': { translation: 'Doigt', translationEn: 'Finger', illustration: '👆', audio: 'Sw-kidole' },
  'Jino': { translation: 'Dent', translationEn: 'Tooth', illustration: '🦷', audio: 'Sw-jino' },
  'Ulimi': { translation: 'Langue', translationEn: 'Tongue', illustration: '👅', audio: 'Sw-ulimi' },
  'Nywele': { translation: 'Cheveux', translationEn: 'Hair', illustration: '💇', audio: 'Sw-nywele' },
  'Kidole cha mguu': { translation: 'Orteil', translationEn: 'Toe', illustration: '🦶', audio: 'Sw-kidole_cha_mguu' },
  'Kucha': { translation: 'Ongle', translationEn: 'Nail', illustration: '💅', audio: 'Sw-kucha' },
  'Bega': { translation: 'Épaule', translationEn: 'Shoulder', illustration: '🙆', audio: 'Sw-bega' },
  'Ini': { translation: 'Foie', translationEn: 'Liver', illustration: '', audio: 'Sw-ini' },
    'Damu': { translation: 'Sang', translationEn: 'Blood', illustration: '🫀', audio: 'Sw-damu' },
   'Tako': { translation: 'Fesse', translationEn: 'Buttock', illustration: '', audio: 'Sw-tako' },
};

export default corps;

export {};
